// src/components/ProtectedRoute.js
import { Navigate } from "react-router-dom";


const ProtectedRoute = ({ children }) => {
  const sessioncode = localStorage.getItem("token");

  if (!sessioncode) {
    return <Navigate to="/authentication/sign-in" replace />;
  }

  return children;
};


export default ProtectedRoute;